const routes = {
  createSaleInvoice: 'sale-invoice',
  getSaleInvoices: 'sale-invoice',
  getSaleInvoiceById: 'sale-invoice/',
  updateSaleInvoice: 'sale-invoice/',
  deleteSaleInvoice: 'sale-invoice/',
  getCustomerByPhone: 'customer/phone/',
};

export default routes